import { useEffect } from 'react';

import { Badge } from '~/components/ui/badge';
import { cn } from '~/utils';

export type SuggestionsDropdownProps = {
  className?: string;
  handleBlur?: () => void;
  handleSuggestionClick?: (suggestions: string) => void;
  highlightedSuggestion?: number;
  left?: string;
  onSuggestionOpen?: () => void;
  preserveFocus?: () => void;
  suggestions?: string[];
  top?: string;
};
export const SuggestionsDropdown = ({
  suggestions,
  className,
  left,
  top,
  handleBlur,
  handleSuggestionClick,
  preserveFocus = () => {},
  highlightedSuggestion = -1,
}: SuggestionsDropdownProps) => {
  useEffect(() => {
    preserveFocus?.();
  }, [preserveFocus]);

  return (
    <div
      className={cn(
        className,
        'border-neutral-250 bg-neutral-0 absolute z-10 rounded-md border',
      )}
      style={{ left, top }}
      onBlur={handleBlur}
    >
      {suggestions?.map((suggestion, index) => (
        <div
          className={cn(
            'border-neutral-250 cursor-pointer border-b px-4 py-2 font-mono',
            'text-xs text-neutral-600 first:rounded-t-md last:rounded-b-md last:border-b-0 hover:bg-neutral-100',
            {
              'bg-neutral-100': highlightedSuggestion === index,
            },
          )}
          onClick={() => handleSuggestionClick?.(`{{ .${suggestion} }}`)}
          key={`${suggestion}-${index}`}
        >
          <Badge variant="variables">{`{{ .${suggestion} }}`}</Badge>
        </div>
      ))}
    </div>
  );
};
